export default __webpack_public_path__ + "static/aimanErbad-436bc90fa592e59952973787a16e2764.jpg";